import { render, staticRenderFns } from "./add-user-popup.vue?vue&type=template&id=de877356"
import script from "./add-user-popup.vue?vue&type=script&lang=js"
export * from "./add-user-popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de877356')) {
      api.createRecord('de877356', component.options)
    } else {
      api.reload('de877356', component.options)
    }
    module.hot.accept("./add-user-popup.vue?vue&type=template&id=de877356", function () {
      api.rerender('de877356', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/settings/add-user-popup.vue"
export default component.exports